// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestAttributeChangeGroupId } from './HarvestAttributeChangeGroup';
import { harvestOperationId } from './HarvestOperation';
import { harvestAttributeLineageId } from './HarvestAttributeLineage';
import { harvestTabularColumnLineageId } from './HarvestTabularColumnLineage';
import { harvestOperationAttributeId } from './HarvestOperationAttribute';
import { attributeChangeOp } from './AttributeChangeOp';
import { attributeChangeField } from './AttributeChangeField';
import { invItemId } from './InvItem';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const harvestAttributeChangeEventId = (z.string());
export const harvestAttributeChangeEvent = z.object({
    id: harvestAttributeChangeEventId,
    group_id: harvestAttributeChangeGroupId,
    harvest_operation_id: harvestOperationId,
    attribute_lineage_id: harvestAttributeLineageId,
    column_lineage_id: harvestTabularColumnLineageId.nullable(),
    harvest_operation_attribute_id: harvestOperationAttributeId.nullable(),
    tabular_row_id: z.string().nullable(),
    op: attributeChangeOp,
    field: attributeChangeField.nullable(),
    is_derived: z.boolean(),
    num_old: z.string().nullable(),
    num_new: z.string().nullable(),
    text_old: z.string().nullable(),
    text_new: z.string().nullable(),
    bool_old: z.boolean().nullable(),
    bool_new: z.boolean().nullable(),
    ts_old: z.date().nullable(),
    ts_new: z.date().nullable(),
    inv_item_id_old: invItemId.nullable(),
    inv_item_id_new: invItemId.nullable(),
    file_storage_id_old: fileStorageId.nullable(),
    file_storage_id_new: fileStorageId.nullable(),
    created_at: z.date(),
});
export const harvestAttributeChangeEventInitializer = z.object({
    id: harvestAttributeChangeEventId.optional(),
    group_id: harvestAttributeChangeGroupId,
    harvest_operation_id: harvestOperationId,
    attribute_lineage_id: harvestAttributeLineageId,
    column_lineage_id: harvestTabularColumnLineageId.optional().nullable(),
    harvest_operation_attribute_id: harvestOperationAttributeId.optional().nullable(),
    tabular_row_id: z.string().optional().nullable(),
    op: attributeChangeOp.optional(),
    field: attributeChangeField.optional().nullable(),
    is_derived: z.boolean().optional(),
    num_old: z.string().optional().nullable(),
    num_new: z.string().optional().nullable(),
    text_old: z.string().optional().nullable(),
    text_new: z.string().optional().nullable(),
    bool_old: z.boolean().optional().nullable(),
    bool_new: z.boolean().optional().nullable(),
    ts_old: z.date().optional().nullable(),
    ts_new: z.date().optional().nullable(),
    inv_item_id_old: invItemId.optional().nullable(),
    inv_item_id_new: invItemId.optional().nullable(),
    file_storage_id_old: fileStorageId.optional().nullable(),
    file_storage_id_new: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
});
export const harvestAttributeChangeEventMutator = z.object({
    id: harvestAttributeChangeEventId.optional(),
    group_id: harvestAttributeChangeGroupId.optional(),
    harvest_operation_id: harvestOperationId.optional(),
    attribute_lineage_id: harvestAttributeLineageId.optional(),
    column_lineage_id: harvestTabularColumnLineageId.optional().nullable(),
    harvest_operation_attribute_id: harvestOperationAttributeId.optional().nullable(),
    tabular_row_id: z.string().optional().nullable(),
    op: attributeChangeOp.optional(),
    field: attributeChangeField.optional().nullable(),
    is_derived: z.boolean().optional(),
    num_old: z.string().optional().nullable(),
    num_new: z.string().optional().nullable(),
    text_old: z.string().optional().nullable(),
    text_new: z.string().optional().nullable(),
    bool_old: z.boolean().optional().nullable(),
    bool_new: z.boolean().optional().nullable(),
    ts_old: z.date().optional().nullable(),
    ts_new: z.date().optional().nullable(),
    inv_item_id_old: invItemId.optional().nullable(),
    inv_item_id_new: invItemId.optional().nullable(),
    file_storage_id_old: fileStorageId.optional().nullable(),
    file_storage_id_new: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=HarvestAttributeChangeEvent.js.map